import { useMediaQuery } from '@mantine/hooks'

interface BreakpointServerDefaults {
    isXs?: boolean
    isSm?: boolean
    isMd?: boolean
    isLg?: boolean
    isXl?: boolean
    isBelow990px?: boolean
}

function ssrOptions(serverValue?: boolean) {
    if (serverValue === undefined) {
        return { initialValue: undefined, options: { getInitialValueInEffect: true } }
    }
    return { initialValue: serverValue, options: { getInitialValueInEffect: false } }
}

export function useBreakpoint(serverDefaults?: BreakpointServerDefaults) {
    const xs = ssrOptions(serverDefaults?.isXs)
    const sm = ssrOptions(serverDefaults?.isSm)
    const md = ssrOptions(serverDefaults?.isMd)
    const lg = ssrOptions(serverDefaults?.isLg)
    const xl = ssrOptions(serverDefaults?.isXl)
    const b990 = ssrOptions(serverDefaults?.isBelow990px)

    // Mobile: less than 321px
    const isXs = useMediaQuery('(max-width: 320px)', xs.initialValue, xs.options)
    // Mobile: less than 768px
    const isSm = useMediaQuery('(max-width: 767px)', sm.initialValue, sm.options)
    // Tablet: 768px - 1023px
    const isMd = useMediaQuery('(min-width: 768px) and (max-width: 1023px)', md.initialValue, md.options)
    // Small desktop: 1024px - 1279px
    const isLg = useMediaQuery('(min-width: 1024px) and (max-width: 1279px)', lg.initialValue, lg.options)
    // Large desktop: 1280px+
    const isXl = useMediaQuery('(min-width: 1280px)', xl.initialValue, xl.options)
    // Used for hiding nav buttons
    const isBelow990px = useMediaQuery('(max-width: 990px)', b990.initialValue, b990.options)

    const hasServerDefaults = serverDefaults !== undefined
    const isReady = hasServerDefaults || isSm !== undefined

    return {
        isXs: !!isXs,
        isSm: !!isSm,
        isMd: !!isMd,
        isLg: !!isLg,
        isXl: !!isXl,
        isBelow990px: !!isBelow990px,
        isReady,
    }
}
